import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "row", "template", "position"]

  connect() {
    this.refreshPositions()
  }

  add() {
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.trim())
    this.refreshPositions()
    this.rowTargets[this.rowTargets.length - 1].querySelector("input")?.focus()
  }

  remove(event) {
    event.currentTarget.closest("[data-admin-company-roles-target='row']")?.remove()
    if (this.rowTargets.length === 0) this.add()
    this.refreshPositions()
  }

  moveUp(event) {
    const row = event.currentTarget.closest("[data-admin-company-roles-target='row']")
    if (row?.previousElementSibling) {
      this.listTarget.insertBefore(row, row.previousElementSibling)
      this.refreshPositions()
    }
  }

  moveDown(event) {
    const row = event.currentTarget.closest("[data-admin-company-roles-target='row']")
    if (row?.nextElementSibling) {
      this.listTarget.insertBefore(row.nextElementSibling, row)
      this.refreshPositions()
    }
  }

  refreshPositions() {
    this.positionTargets.forEach((target, index) => {
      target.textContent = index + 1
    })
  }
}
